export const loadingLength = 8;

/**
 * admins – List of CUApts' admins' email addresses.
 *
 * @remarks
 * This array contains the emails of users who have access to the admin system on CUApts. Each email should be followed with a comment indicating
 * the admin's name. This array should be updated periodically to remove old admins and add new admins.
 *
 * @return {string[]} – An array of admin email addresses.
 */
export const admins: string[] = [
  'gs622@cornell.edu', // Grace
  'tpp38@cornell.edu', // Sophia
  'km653@cornell.edu', // Kevin
  'egk46@cornell.edu', // Ella
  'dj263@cornell.edu', // Daniel
  'ko353@cornell.edu', // Kea-Roy
  'cl2622@cornell.edu', // Casper
  'dm769@cornell.edu', // David
  'jl3587@cornell.edu', // Janet
  'vw92@cornell.edu', // Vicky
  'pt427@cornell.edu', // Parsa
  'jl4427@cornell.edu', // Jaeyoung
  'jig47@cornell.edu', // Jacob
  'el728@cornell.edu', // Erica
  'aa2724@cornell.edu', // Arsh
  'lsp75@cornell.edu', // Lauren
  'jr2293@cornell.edu', // Jasmine
  'zw757@cornell.edu', // May
  'csl238@cornell.edu', // Celline
  'cy562@cornell.edu', // Colleen
  'nt387@cornell.edu', // Nigel
  'bs887@cornell.edu', // Brian
  'its9@cornell.edu', // Isabella
  'ik365@cornell.edu', // Ishika
  'kh862@cornell.edu', // Kai
  'km2253@cornell.edu', // Karan
  'mk2699@cornell.edu', // Martha
];
